import { defineStyle } from '@chakra-ui/react';

const theme = defineStyle({
  root: {
    ml: '-3px',
    padding: '24px 0 48px',
    mt: '48px',
    border: '1px solid border',
    position: 'sticky',
    bottom: '-48px',
    backgroundColor: 'background',
  },
});

export default theme;
